// Plain-language definitions of CD-dashboard concepts. Keep each entry short
// (one sentence, two max) so the InfoPopover stays readable without scrolling.
// Product/docs can edit these without touching component code.

export interface GlossaryEntry {
  term: string;
  body: string;
}

export const GLOSSARY = {
  needsAttention: {
    term: 'Needs Attention',
    body:
      "Failures from the last 7 days that haven't been superseded by a newer successful deploy. " +
      'If a newer version of the same service succeeded, the older failure is hidden.',
  },
  dynamicEnvironment: {
    term: 'Dynamic Environment',
    body:
      'A short-lived environment (has a TTL) that is automatically destroyed after a period. ' +
      'Typically created per-branch or per-feature.',
  },
  deployAll: {
    term: 'Deploy All',
    body:
      'A grouped job that deploys every service in an environment at once. ' +
      'Listed as a single row rather than one row per service.',
  },
  destroyAll: {
    term: 'Destroy All',
    body:
      'A grouped job that tears down every service in a dynamic environment. ' +
      'Used when an ephemeral environment reaches end of life.',
  },
  servicesLens: {
    term: 'Services lens',
    body: 'Current state across your services — what is healthy, deploying, failing, or pending right now.',
  },
  releasesLens: {
    term: 'Releases lens',
    body: 'Follow a version through dev → stage → prod and see where it stalled, failed, or succeeded.',
  },
  jobId: {
    term: 'Job ID',
    body:
      'A unique identifier for a specific deployable unit (e.g. a lambda, an ECS service). ' +
      'Jobs live in the Catalog; Job IDs appear on every deployment record.',
  },
  deploymentId: {
    term: 'Deployment ID',
    body:
      'A unique identifier for a single deployment attempt. Paste one into search to find it — ' +
      'it combines with other filters instead of replacing them.',
  },
  savedFilters: {
    term: 'Saved Filters',
    body: 'Save the current search as a reusable preset. Double-click a saved filter to rename it.',
  },
} as const;

export type GlossaryKey = keyof typeof GLOSSARY;

export const getGlossaryEntry = (key: GlossaryKey): GlossaryEntry => GLOSSARY[key];
